import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class ChatBubble extends PureComponent {
  render() {
    const { left, right, timestamp, hasAvatar, children } = this.props;

    const className = classNames({
      'bubble-wrap': true,
      me: right,
      you: left,
      'has-avatar': hasAvatar,
    });

    return (
      <div className={className}>
        { left && <div className="ls"><div className="tail" /></div> }
        <div className="bubble">
          {children}
        </div>
        { right && <div className="rs"><div className="tail" /></div> }
        <div className="timestamp">
          {timestamp}
        </div>
      </div>
    );
  }
}

ChatBubble.defaultProps = {
  hasAvatar: false,
  left: false,
  right: false,
};

ChatBubble.propTypes = {
  children: PropTypes.any,
  hasAvatar: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
  timestamp: PropTypes.string,
};

export default ChatBubble;
